export const yieldToMain = () => new Promise((resolve) => {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(() => resolve(), { timeout: 50 });
  } else {
    setTimeout(resolve, 0);
  }
});
